import type { Dialog } from '@common/types'
import { stringify as stringifyQs } from 'qs'
import urlJoin from 'url-join'

export const oversightScenarioSection = '/oversight-scenarios/'

export type OversightScenarioListUrlDialog = 'new'

export type OversightScenarioListUrlQueryParams = Dialog<OversightScenarioListUrlDialog>

export const oversightScenarioListUrl = (params?: OversightScenarioListUrlQueryParams): string => {
  if (params === undefined) {
    return oversightScenarioSection
  }

  return urlJoin(oversightScenarioSection, '?' + stringifyQs(params))
}

export const oversightScenarioDetailPath = ':id'

export const oversightScenarioDetailUrl = (id: string): string =>
  urlJoin(oversightScenarioSection, encodeURIComponent(id))
